
Vue.component('category', {
    props: {
        fieldid: {

        },
        fielddata: {
            type: Object
        },
        selectedvalue: {}
    },
    computed: {
        thisfield () {
            if (this.fielddata && this.fieldid) {
                return this.fielddata[this.fieldid]
            }
        },
        options () {
            if (this.fieldid && slideTranslations[this.fieldid]) {
                return slideTranslations[this.fieldid];
            }
            return false;
        },
        selected () {
            if (this.options) {
                let newobj = {};
                let $this = this;
                Object.keys(this.options).forEach((key) => {
                    if (key == $this.selectedvalue) {
                        newobj[$this.selectedvalue] = true;
                    }
                })
                return newobj
            }
        }        
    },
    mounted () {
        this.$emit('updatecategory', this.fieldid, this.selected);

    },
    methods: {
        update () {            
            this.$emit('updatecategory', this.fieldid, this.selected);
        }
    }

});